(() => {
  const tools = document.querySelector('[data-bn-a11y-tools]');
  if (!tools) return;

  const root = document.documentElement;
  const dialog = tools.querySelector('[data-bn-a11y-dialog]');
  const openButton = tools.querySelector('[data-bn-a11y-open]');
  const closeButton = tools.querySelector('[data-bn-a11y-close]');
  const status = tools.querySelector('[data-bn-a11y-status]');
  const storageKey = 'black-natasha-accessibility-v1';
  const initialState = { fontSize: 0, contrast: false, links: false, motion: false };
  let state = { ...initialState };

  try {
    state = { ...initialState, ...JSON.parse(window.localStorage.getItem(storageKey) || '{}') };
  } catch (_error) {
    state = { ...initialState };
  }

  const announce = (message) => {
    if (!status) return;
    status.textContent = '';
    window.requestAnimationFrame(() => { status.textContent = message; });
  };

  const applyState = () => {
    root.classList.toggle('bn-a11y-font-lg', state.fontSize === 1);
    root.classList.toggle('bn-a11y-font-xl', state.fontSize === 2);
    root.classList.toggle('bn-a11y-contrast', state.contrast);
    root.classList.toggle('bn-a11y-links', state.links);
    root.classList.toggle('bn-a11y-no-motion', state.motion);

    tools.querySelector('[data-bn-a11y-action="contrast"]')?.setAttribute('aria-pressed', String(state.contrast));
    tools.querySelector('[data-bn-a11y-action="links"]')?.setAttribute('aria-pressed', String(state.links));
    tools.querySelector('[data-bn-a11y-action="motion"]')?.setAttribute('aria-pressed', String(state.motion));

    try {
      window.localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (_error) {
      // The controls still work for the current visit when storage is unavailable.
    }
  };

  const openDialog = () => {
    if (!dialog) return;
    openButton?.setAttribute('aria-expanded', 'true');
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    closeButton?.focus();
  };

  const closeDialog = () => {
    if (!dialog) return;
    openButton?.setAttribute('aria-expanded', 'false');
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    openButton?.focus();
  };

  openButton?.addEventListener('click', openDialog);
  closeButton?.addEventListener('click', closeDialog);
  dialog?.addEventListener('close', () => openButton?.setAttribute('aria-expanded', 'false'));
  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });

  tools.querySelectorAll('[data-bn-a11y-action]').forEach((button) => {
    button.addEventListener('click', () => {
      switch (button.dataset.bnA11yAction) {
        case 'font-up':
          state.fontSize = Math.min(2, state.fontSize + 1);
          announce(state.fontSize === 2 ? 'הטקסט הוגדל לגודל המרבי' : 'הטקסט הוגדל');
          break;
        case 'font-down':
          state.fontSize = Math.max(0, state.fontSize - 1);
          announce(state.fontSize === 0 ? 'גודל הטקסט חזר לברירת המחדל' : 'הטקסט הוקטן');
          break;
        case 'contrast':
          state.contrast = !state.contrast;
          announce(state.contrast ? 'ניגודיות גבוהה הופעלה' : 'ניגודיות גבוהה בוטלה');
          break;
        case 'links':
          state.links = !state.links;
          announce(state.links ? 'הדגשת קישורים הופעלה' : 'הדגשת קישורים בוטלה');
          break;
        case 'motion':
          state.motion = !state.motion;
          announce(state.motion ? 'אנימציות נעצרו' : 'אנימציות הופעלו');
          break;
        case 'reset':
          state = { ...initialState };
          announce('כל התאמות הנגישות אופסו');
          break;
      }
      applyState();
    });
  });

  tools.querySelector('[data-bn-a11y-skip]')?.addEventListener('click', () => {
    closeDialog();
    const main = document.getElementById('MainContent');
    if (!main) return;
    if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
    main.focus({ preventScroll: true });
    main.scrollIntoView({ behavior: state.motion ? 'auto' : 'smooth', block: 'start' });
  });

  applyState();
})();
